import * as React from 'react'
import { Input } from '@/components/ui/input'
import { cn } from '@/helpers/utils'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import countries from '@/helpers/countries.json'

const dialCodeSize = dialCode => {
  if (!dialCode) return ''
  const length = dialCode.length
  if (length === 2) return 'pl-8'
  if (length === 3) return 'pl-10'
  if (length === 4) return 'pl-12'
  return 'pl-14'
}

function PhoneInput({ value = {}, onChange, error = {} }) {
  const { phoneCountryCode = '', phoneNumber = '' } = value

  const dialCode = React.useMemo(() => {
    if (!phoneCountryCode) return null
    return countries.find(country => country.code === phoneCountryCode)?.dialCode
  }, [phoneCountryCode])

  const countryHasError = !!error.phoneCountryCode
  const phoneHasError = !!error.phoneNumber

  return (
    <div>
      <div>
        <Select
          value={phoneCountryCode}
          onValueChange={(newCountryCode) =>
            onChange({ phoneCountryCode: newCountryCode, phoneNumber })}
          className='rounded-t-lg'
        >
          <SelectTrigger className='w-full mb-0 rounded-none rounded-t-md border-b-0 focus:border-b focus:border-input'>
            <SelectValue placeholder='Choose a country' />
          </SelectTrigger>
          <SelectContent className='rounded-b-lg'>
            {countries.map(country => (
              <SelectItem key={country.code} value={country.code}>
                {country.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className='relative'>
        <If condition={dialCode}>
          <span className='absolute inset-y-0 left-0 flex items-center pl-3 text-foreground-muted pointer-events-none md:text-sm md:mt-[1px]'>
            {dialCode}
          </span>
        </If>
        <Input
          type='tel'
          value={phoneNumber}
          onChange={(e) =>
            onChange({ phoneCountryCode, phoneNumber: e.target.value })}
          placeholder='Phone number'
          className={cn(
            'rounded-none rounded-b-md focus:ring-0',
            dialCodeSize(dialCode)
          )}
          onKeyDown={event => {
            if (!/[0-9]/.test(event.key) && !event.ctrlKey && !event.metaKey && event.key.length === 1) {
              event.preventDefault()
            }
          }}
        />
      </div>
    </div>
  )
}

export { PhoneInput }
